export function getUserVal(material, column, users) {
  const userField = column.slice(5)
  // FIXME: Find the user entry more efficiently than brute force search
  for (var i = 0; i < users.length; i++) {
    if (users[i].userId === material.userId) {
      return users[i][userField]
    }
  }
  return null
}

export function getComparator(order, orderBy, users) {
  var valA1, valB1;
  const collator = new Intl.Collator(undefined, { sensitivity: 'base' });

  return (a, b) => {
    const sign1 = (order === 'desc') ? -1 : 1;

    if (users && orderBy?.startsWith('user.')) {
      valA1 = getUserVal(a, orderBy, users)
      valB1 = getUserVal(b, orderBy, users)
    } else {
      valA1 = a[orderBy]
      valB1 = b[orderBy]
    }

    // If primary sort is by createdAt, secondary sort is by name in ascending order
    // If primary sort is by name, secondary sort is by createdAt in descending order
    const orderBy2 = (orderBy === 'createdAt') ? 'name' : 'createdAt';
    const sign2 = (orderBy === 'createdAt') ? 1 : -1;
    const valA2 = a[orderBy2];
    const valB2 = b[orderBy2];

    return sign1*collator.compare(valA1, valB1) || sign2*collator.compare(valA2, valB2);
  }
}

export function getComparatorFolders(order, orderBy) {
  const sign = (orderBy === 'name' && order === 'desc') ? -1 : 1;
  const collator = new Intl.Collator(undefined, { sensitivity: 'base' });
  return (a, b) => sign*collator.compare(a, b);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

export function getCellHeader (column) {
  var val
  if (column === 'text') {
    val = 'description'
  } else if (column === 'success') {
    val = 'Result'
  } else if (column === 'createdAt') {
    val = 'Date created'
  } else if (column === 'imports') {
    val = 'Materials'
  } else {
    val = column
  }
  // Convert camel case column name to formatted column header:
  // - Insert space before each capital letter
  val = val.replace(/([A-Z])/g, ' $1').trim()
  // - Replace dots with spaces
  val = val.replace('.', ' ')
  // - Capitalise first letter and de-capitalise the other letters
  val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase()
  // - Replace single word 'id' with 'ID' using regex
  val = val.replace(/\bid\b/g, 'ID')
  // - Replace single word 'url' with 'URL' using regex
  val = val.replace(/\bUrl\b/g, 'URL')

  return val
}

export function getNewOrder(newOrderBy, order, orderBy) {
  const newOrderDesc = (
    (orderBy === newOrderBy) && (order === 'asc') ||
    (newOrderBy === 'createdAt') && (orderBy !== newOrderBy)
  );
  const newOrder = newOrderDesc ? 'desc' : 'asc';
  return newOrder;
}
